export default {
  aigc_dataAnalysis_title: 'ChatBI - Data Analysis',
  aigc_dataAnalysis_view: 'View samples',
  aigc_dataAnalysis_generate: 'Generate',
  aigc_dataAnalysis_copy: 'Copy',
  aigc_dataAnalysis_refine: 'Refine',
  aigc_dataAnalysis_explain: 'Explain',
  aigc_dataAnalysis_evaluate: 'Evaluate',
  aigc_dataAnalysis_recommend: 'Recommend',
  aigc_dataAnalysis_visualization: 'visualization ',
  aigc_dataAnalysis_ready: 'Ready? Upload a file to begin.',
  aigc_dataAnalysis_click_or_drag: 'Click or drag file to this area to upload',
  aigc_dataAnalysis_upload_type: 'Upload .json,.xlsx,.xls,.csv files to generate a visualization',
  aigc_dataAnalysis_don_have_data: `Don't have data? Try any of the files below`,
  aigc_dataAnalysis_data_summary: 'Data Summary',
  aigc_dataAnalysis_goals: 'Goals',
  aigc_dataAnalysis_an_enriched: 'An enriched representation of the data (with predicted semantic types and descriptions)',
  aigc_dataAnalysis_view_raw_summary: 'View raw summary?',
  aigc_dataAnalysis_goal_exploration: 'Goal Exploration',
  aigc_dataAnalysis_automatically: 'A list of data exploration targets automatically generated based on the above data summary.',
  aigc_dataAnalysis_visualization_generation: 'Visualization Generation',
  aigc_dataAnalysis_select_goal: 'Select a goal above or describe a new visualization goal to generate a visualization.',
  aigc_dataAnalysis_modify_chart: 'Modify Chart with Natural Language commands.',
  aigc_dataAnalysis_visualization_created: 'How was this visualization created? See the specifications and code below.',
  aigc_dataAnalysis_PCU_over_time: ' What is the trend of PCU over time?',
  aigc_dataAnalysis_python_code: 'Python Code',
  aigc_dataAnalysis_generate_an_explanation: 'Use the explain visualization button below to generate an explanation for the chart',
  aigc_dataAnalysis_evaluate_the_chart: 'Evaluate the chart',
  aigc_dataAnalysis_generate_self_evaluation: 'Use the evaluate visualization button below to generate self-evaluation scores for the chart',
  aigc_dataAnalysis_generate_similar_charts: ' Generate similar charts.',
  aigc_dataAnalysis_generate_recommendations: 'Generate Recommendations',
  aigc_dataAnalysis_change_x_axis: 'Change x axis label to Meters per Second',
  aigc_dataAnalysis_evaluated_across: `The visualization has been evaluated across multiple dimensions. Select
  a dimension to view rationale for the score`,
  aigc_dataAnalysis_unique_values: `Unique values`,
  aigc_dataAnalysis_max: `max`,
  aigc_dataAnalysis_min: `min`,
  aigc_dataAnalysis_std: `std`,
  aigc_dataAnalysis_no_data: `Loading failed, please refresh the page.`,
  aigc_dataAnalysis_refresh: `Refresh`,
  aigc_dataAnalysis_dictionary_below: `The dataset is summarized as the dictionary below.`,
  aigc_dataAnalysis_raw_dataset_summary: `Raw Dataset Summary`,
  aigc_dataAnalysis_successful: `Successful replication`,
  aigc_dataAnalysis_replication: `Replication failure`,

};